import React from "react";
import styles from "./EditorFloating.module.css";

const EditorFloatingLoader = () => {
  return (
    <div className={styles.loader}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default EditorFloatingLoader;
